import { useRouter } from "next/router";
import React, { useState } from "react";
import { Col, Container, FormControl, FormGroup, Row } from "react-bootstrap";
import Button from "../../../components/Misc/Button";
import ErrorMessageInfo from "../../../components/Misc/ErrorMessageInfo";
import { apiUrl } from "../../../utilities/Helpers";
import { validateEmail } from "../../../utilities/validations";
import { useAppContext } from "../../../_context";
import { responseMessages } from "../../../components/Pages/Premium/helpers/constants";

function ResetPassword() {
  const [{ tx }] = useAppContext();

  const router = useRouter();
  const [emailValue, setEmailValue] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const onResetPassword = async (e) => {
    e.preventDefault();

    if (!validateEmail(emailValue)) {
      setErrorMessage(tx["Invalid email format"]);
      return;
    }

    const payload = {
      email: emailValue,
    };
    setIsLoading(true);
    try {
      const res = await fetch(apiUrl("/api/v1/users/requestNewPassword"), {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "x-api-version": "New",
        },
        body: JSON.stringify(payload),
      });
      const data = await res.json();
      setIsLoading(false);
      if (data === responseMessages.requestRegistered) {
        router.push("reset-password/check-mail");
      }
    } catch (error) {
      setIsLoading(false);
    }
  };

  return (
    <Container>
      <form onSubmit={onResetPassword} className="mx-lg-8 px-lg-3">
        <Row>
          <Col md={12} lg={12}>
            <h2>{tx["Forgot password?"]}</h2>
            <p className="mb-4">
              {
                tx[
                  "Enter your registered email address and we'll send you a secure link to setup a new password."
                ]
              }
            </p>
          </Col>
          <Col md={7} lg={6}>
            <FormGroup className="mb-3">
              <label className="form-label" htmlFor="cancelation-email">
                {tx["Email"]}
              </label>
              <FormControl
                id="cancelation-email"
                value={emailValue}
                onChange={(e) => setEmailValue(e.target.value)}
              />
            </FormGroup>
            {errorMessage && (
              <div className="my-4">
                <ErrorMessageInfo>{errorMessage}</ErrorMessageInfo>
              </div>
            )}
            <Button
              className="w-100 py-0 py-lg-0 px-0 px-lg-0"
              type="submit"
              isLoading={isLoading}>
              {tx["Reset password"]}
            </Button>
          </Col>
        </Row>
      </form>
    </Container>
  );
}

export default ResetPassword;
